import {
  DataSourceAutoImportMode,
  DataSourceFigmaScope,
  DataSourceRemoteType,
  ImportJobState,
} from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTOImportJob = z.object({
  id: z.string(),
  designSystemId: z.string(),
  designSystemVersionId: z.string(),
  operation: z.literal("Import"),
  createdAt: z.coerce.date(),
  stateChangedAt: z.coerce.date(),
  state: ImportJobState,
  sourceIds: z.string().array(),
});

export const DTOImportJobResponse = z.object({
  job: DTOImportJob,
});

export type DTOImportJob = z.infer<typeof DTOImportJob>;
export type DTOImportJobResponse = z.infer<typeof DTOImportJobResponse>;

//
// Write
//

export const DTOBffFigmaImportRequestBody = z.object({
  type: z.literal(DataSourceRemoteType.Enum.Figma),
  brandPersistentId: z.string().optional(),
  fileId: z.string(),
  scope: DataSourceFigmaScope,
  autoImportMode: DataSourceAutoImportMode,
});

export const DTOBffUploadImportRequestBody = z.object({
  type: z
    .enum([DataSourceRemoteType.Enum.FigmaVariablesPlugin, "Upload"])
    .transform(v => DataSourceRemoteType.Enum.FigmaVariablesPlugin),
  brandPersistentId: z.string().optional(),
  sourceName: z.string().optional(),
  remoteId: z.string(),
  isTokenTypeSplitEnabled: z.boolean().optional(),
  payload: z.any(),
});

export const DTOBffImportRequestBody = z.discriminatedUnion("type", [
  DTOBffFigmaImportRequestBody,
  DTOBffUploadImportRequestBody,
]);

export type DTOBffFigmaImportRequestBody = z.infer<typeof DTOBffFigmaImportRequestBody>;
export type DTOBffUploadImportRequestBody = z.infer<typeof DTOBffUploadImportRequestBody>;
export type DTOBffImportRequestBody = z.infer<typeof DTOBffImportRequestBody>;
